import { useState, useEffect } from 'react';
import { isBrowser } from '@web3/base-utils';

export const useVisible = () => {
  const [visible, setVisible] = useState(false);

  const open = () => {
    setVisible(true);
  };

  const close = () => {
    setVisible(false);
  };

  const toggle = () => {
    setVisible(!visible);
  };

  return {
    visible,
    setVisible,
    open,
    close,
    toggle,
  };
};

/**
 * 判断当前窗口是否在前台
 */
export const useVisibility = () => {
  const [isVisibility, setIsVisibility] = useState(true);

  useEffect(() => {
    if (!isBrowser) return;

    const handleVisibilityChange = () => {
      setIsVisibility(document.visibilityState === 'visible');
    };

    // 监听 visibilitychange 事件
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // 清除事件监听器
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return { isVisibility };
};
